import React from "react";
import { useLocation } from "react-router-dom";
import ModuleSubtopic from "../../../ModuleSubtopic";

const OOP_Polymorphism = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || { subtopics: [], subjectPath: '' };

  return (
    <ModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Dynamic Polymorphism, Virtual Functions, Pure Virtual Functions & Abstract Classes"
      videos={[
        "https://www.youtube.com/embed/uc_Hr10cBBE", // Polymorphism in C++
        "https://www.youtube.com/embed/TqLPDwiQWS0", // Virtual Function in C++
        "https://www.youtube.com/embed/JU8DbwBvOWE", // Virtual Functions & Abstract Classes in C++
        "https://www.youtube.com/embed/gtkh3KxcX4U", // Pure Virtual Functions in C++
        "https://www.youtube.com/embed/9K3FrxWmlpE", // Pure Virtual Functions & Abstract Classes in C++
        "https://www.youtube.com/embed/7Dy0uw0zLy0", // Abstract Classes in C++
      ]}
      takeaways={[
        { text: "Learn all the theoretical concepts with syntax and code examples." },
        { text: "Theory questions are commonly asked, such as differences, advantages, and use cases." },
        { text: "Understand the differences between function overriding and function overloading." },
      ]}
      questions={[
        "1) Illustrate the use of virtual functions to achieve dynamic polymorphism with an example program. Highlight the rules for using the virtual function in C++ programs.",
        "2) How does function overloading differ from the usage of virtual functions? Explain with an example.",
        "3) Compare and contrast between virtual functions and pure virtual functions.",
        "4) Consider a class to check for the strength of a password. In this regard, a function password_strength() is to be implemented. Assume that the function password_strength() has to print the total number of blank spaces, consonants, and vowels in the given string. Implement the mentioned example in C++ using a pure virtual function.",
      ]}
      exampleVideos={[]} // No specific example question videos provided
    />
);
}

export default OOP_Polymorphism;
